import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/App.css";
import "./styles/globals.css";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);

// Register service worker for PWA functionality.
// Skip registration while react-snap is pre-rendering (its headless Chrome
// reports a "ReactSnap" user agent). A cache-first service worker prevents
// puppeteer's navigation from settling, causing the postbuild step to time out.
const isReactSnap = navigator.userAgent === "ReactSnap";
if (!isReactSnap) {
	serviceWorkerRegistration.register();
}
